import { render, staticRenderFns } from "./DateTimeDisplay.vue?vue&type=template&id=c1106e52&scoped=true&"
import script from "./DateTimeDisplay.vue?vue&type=script&lang=ts&"
export * from "./DateTimeDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./DateTimeDisplay.vue?vue&type=style&index=0&id=c1106e52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1106e52",
  null
  
)

export default component.exports